// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3er26","icon":"SortAdornment_icon__28_pl","up":"SortAdornment_up__12ih8","down":"SortAdornment_down__3caxq","active":"SortAdornment_active__2toph"};